module.exports = __webpack_public_path__ + "static/media/stats-bars6.4bdf8f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/stats-bars6.svg
// module id = 3607
// module chunks = 7